/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A Vikimap service module to use for a Vikimap driven application. Supports Accedo One, JSON and Middleware services. (@accedo/vdkweb-vikimap) 4.0.6
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toQueryString = void 0;

var toQueryString = function toQueryString(obj) {
  if (!obj) {
    return '';
  }

  return Object.keys(obj).map(function (key) {
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key]));
  }).join('&');
};

exports.toQueryString = toQueryString;